import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import classnames from 'classnames';
import StudentPage from '../../views/StudentPage';

class ReligionUpdate extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			casName : '',
			communi : '',
			relName : '',
			_message : '',
			value : '',
			alertClass :'',
			shown : false,
			index : '',
			activeTab: '2',
			posts : [],
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onRelSubmit = this.onRelSubmit.bind(this);
		this.toggle = this.toggle.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** set value **/
	handleInputChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.casName && this.state.communi){
			
			PostData('caste/addcaste',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Caste has been Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("casform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** submit religion form **/
	onRelSubmit(e){
		e.preventDefault();
		
		if(this.state.relName){
			
			PostData('caste/updatereligion',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Religion Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("releditform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});	
		}
	}
	
/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getreligion();
		this.getdata();
	}
	
	getdata(){
		
		GetData('caste/getcaste').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get religion **/
	getreligion(){
		
		GetData('caste/getreligionbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					relName : res[0]['religion']
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/settings/caste' />);
	}

	/**  set value to community **/
	this.community = [
		{value : '', name : 'Select'},
		{value : 'ST', name : 'ST'},
		{value : 'SC-Arunthathiyar', name : 'SC-Arunthathiyar'},
		{value : 'SC', name : 'SC'},
		{value : 'MBC', name : 'MBC'},
		{value : 'DNC', name : 'DNC'},
		{value : 'BC', name : 'BC'},
		{value : 'BCM', name : 'BCM'},
		{value : 'BC', name : 'BC'},
		{value : 'OC', name : 'OC'},
	];
  
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<Row>
			  <Col md="12">
				<Nav tabs>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '1' })}
					  onClick={() => { this.toggle('1'); }}
					>
					  Student caste
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '2' })}
					  onClick={() => { this.toggle('2'); }}
					>
					  Student Religion
					</NavLink>
				  </NavItem>
				</Nav>
				<TabContent activeTab={this.state.activeTab}>
				  <TabPane tabId="1">
					<Row>
					<Col md="6">
					<Card>
					  <form action="" method="post" role="form" id="casform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Add Caste</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Caste Name</Label>
								  <Input type="text" name="casName" id="name" required onChange={this.onChange} />
								</FormGroup>
							</Col>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Community</Label>
								  <select name="communi" className="form-control" onChange={this.onChange} required>
									{this.community.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col>
					<Col md="6">
						<Table responsive bordered>
							<thead>
								<tr>
									<th>S.No</th>
									<th>Caste</th>
									<th width="100">Manage</th>
								</tr>
							</thead>
							<tbody>
								{this.state.posts.map(item =>
								 
									<tr key = {item}>
										<td>{item.id}</td>
										<td>{item.caste} - {item.community}</td>
										<td>
											<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
											&nbsp;&nbsp;
											<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
										</td>
									</tr>
								)}
							</tbody>
						</Table>
					</Col>
					</Row>
				  </TabPane>
				  <TabPane tabId="2">
					<Row>
					<Col md="6">
					<Card>
					  <form action="" method="post" role="form" id="releditform" encType="multipart/form-data" onSubmit={this.onRelSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Edit Religion</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Religion Name</Label>
								  <Input type="text" name="relName" id="name" required onChange={this.handleInputChange} value={this.state.relName} />
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col>
					<Col md="6">
						
					</Col>
					</Row>
				  </TabPane>
				</TabContent>
			  </Col>
			</Row>
			</div>
		</div>
	);
  }
}

export default ReligionUpdate;



// WEBPACK FOOTER //
// ./src/settings/Religion/ReligionUpdate.js